import { get } from './helpers/fetch';
import { CONFIG_URL } from '../constants/urls';

export default class ConfigDAO {
  static fetch() {
    return fetch(CONFIG_URL).then(resp => resp.json());
  }
}
